import { render, staticRenderFns } from "./FAQLayout.vue?vue&type=template&id=25a61ddf&"
import script from "./FAQLayout.vue?vue&type=script&lang=js&"
export * from "./FAQLayout.vue?vue&type=script&lang=js&"
import style0 from "./FAQLayout.vue?vue&type=style&index=0&id=25a61ddf&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a61ddf')) {
      api.createRecord('25a61ddf', component.options)
    } else {
      api.reload('25a61ddf', component.options)
    }
    module.hot.accept("./FAQLayout.vue?vue&type=template&id=25a61ddf&", function () {
      api.rerender('25a61ddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/FAQLayout.vue"
export default component.exports